import { render, staticRenderFns } from "./PollVoteList.vue?vue&type=template&id=3a130ed3&scoped=true&"
import script from "./PollVoteList.vue?vue&type=script&lang=js&"
export * from "./PollVoteList.vue?vue&type=script&lang=js&"
import style0 from "./PollVoteList.vue?vue&type=style&index=0&id=3a130ed3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a130ed3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VIcon})
